const FILTER_POPOVER_ROOT_CLASS = 'filter-chip-popover';

/**
 * Keep nested dropdown/date-picker overlays inside the filter popover.
 *
 * Ant Design renders these overlays into document.body by default. When a
 * filter chip editor is open, option clicks in that portal can be treated as
 * outside clicks by the parent Popover, closing the editor before the first
 * selection reliably commits.
 */
export function getFilterPopupContainer(triggerNode: HTMLElement): HTMLElement {
    return triggerNode.closest<HTMLElement>(`.${FILTER_POPOVER_ROOT_CLASS}`) ?? document.body;
}
